<div class="d-flex justify-content-between mb-2">
    <h5 class="fs-18 fw600 text-bodyGrey mb-0">Assumptions</h5>
    <button class="btn-secondary btn-xs" id="editAssumptionButton" (click)="openEditAssumptionModal()"> Edit </button>
</div>
<div class="card cardTyp0">
    <div class="card-body minh-auto">
        <div class="row">
            <div *ngIf="source == 'edf'" class="col-sm-6 mb-3">
                <!-- <div class="row"> -->
                <!-- <ng-container *ngIf="source == 'edf'"> -->
                    <!-- Single Rate Configuration -->
                    <ng-container *ngIf="assumptionData?.energy?.electricityRateConfig?.rateType === 'single'">
                        <label class="fs-14 fw400 text-brightPurple mb-1">Electricity Rate (Single)</label>
                        <p class="fs-14 fw400 mb-1"><strong>Unit Rate:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.single?.unitRate * 100 | number: '1.0-2') || '0' }} p/kWh</p>
                        <p class="fs-14 fw400 mb-0"><strong>Standing Charge:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.single?.standingCharge | number: '1.0-2') || '0' }} p/day</p>
                    </ng-container>

                    <!-- Day-Night Rate Configuration -->
                    <ng-container *ngIf="assumptionData?.energy?.electricityRateConfig?.rateType === 'dayNight'">
                        <label class="fs-14 fw400 text-brightPurple mb-1">Electricity Rate (Day-Night)</label>
                        <p class="fs-14 fw400 mb-1"><strong>Day Rate:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.dayNight?.dayRate | number: '1.0-2') || '0' }} p/kWh ({{ assumptionData?.energy?.electricityRateConfig?.dayNight?.dayStartTime }} - {{ assumptionData?.energy?.electricityRateConfig?.dayNight?.dayEndTime }})</p>
                        <p class="fs-14 fw400 mb-1"><strong>Night Rate:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.dayNight?.nightRate | number: '1.0-2') || '0' }} p/kWh ({{ assumptionData?.energy?.electricityRateConfig?.dayNight?.dayEndTime }} - {{ assumptionData?.energy?.electricityRateConfig?.dayNight?.dayStartTime }})</p>
                        <p class="fs-14 fw400 mb-0"><strong>Standing Charge:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.dayNight?.standingCharge | number: '1.0-2') || '0' }} p/day</p>
                    </ng-container>

                    <!-- Three-Rate Configuration -->
                    <ng-container *ngIf="assumptionData?.energy?.electricityRateConfig?.rateType === 'threeRate'">
                        <label class="fs-14 fw400 text-brightPurple mb-1">Electricity Rate (Three-Rate)</label>
                        <p class="fs-14 fw400 mb-1"><strong>Weekday:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.threeRate?.weekdayRate | number: '1.0-2') || '0' }} p/kWh ({{ assumptionData?.energy?.electricityRateConfig?.threeRate?.weekdayStart }} - {{ assumptionData?.energy?.electricityRateConfig?.threeRate?.weekdayEnd }})</p>
                        <p class="fs-14 fw400 mb-1"><strong>Evening:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.threeRate?.eveningRate | number: '1.0-2') || '0' }} p/kWh ({{ assumptionData?.energy?.electricityRateConfig?.threeRate?.eveningStart }} - {{ assumptionData?.energy?.electricityRateConfig?.threeRate?.eveningEnd }})</p>
                        <p class="fs-14 fw400 mb-1"><strong>Night:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.threeRate?.nightRate | number: '1.0-2') || '0' }} p/kWh ({{ assumptionData?.energy?.electricityRateConfig?.threeRate?.eveningEnd }} - {{ assumptionData?.energy?.electricityRateConfig?.threeRate?.weekdayStart }})</p>
                        <p class="fs-14 fw400 mb-0"><strong>Standing Charge:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.threeRate?.standingCharge | number: '1.0-2') || '0' }} p/day</p>
                    </ng-container>

                    <!-- Two-Rate Configuration -->
                    <ng-container *ngIf="assumptionData?.energy?.electricityRateConfig?.rateType === 'twoRate'">
                        <label class="fs-14 fw400 text-brightPurple mb-1">Electricity Rate (Two-Rate)</label>
                        <p class="fs-14 fw400 mb-1"><strong>Weekday:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.twoRate?.weekdayRate | number: '1.0-2') || '0' }} p/kWh ({{ assumptionData?.energy?.electricityRateConfig?.twoRate?.weekdayStart }} - {{ assumptionData?.energy?.electricityRateConfig?.twoRate?.weekdayEnd }})</p>
                        <p class="fs-14 fw400 mb-1"><strong>Other Times:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.twoRate?.eveningRate | number: '1.0-2') || '0' }} p/kWh</p>
                        <p class="fs-14 fw400 mb-0"><strong>Standing Charge:</strong> {{ (assumptionData?.energy?.electricityRateConfig?.twoRate?.standingCharge | number: '1.0-2') || '0' }} p/day</p>
                    </ng-container>

                    <!-- Fallback: Legacy Single Rate Format -->
                    <ng-container *ngIf="!assumptionData?.energy?.electricityRateConfig">
                        <label for="unitPriceElec" class="fs-14 fw400 text-brightPurple mb-1">Electricity Unit Price (Rates are in p/kWh)</label>
                        <p class="fs-16 fw400 mb-0">{{(assumptionData?.energy?.elecUnitRate?.value * 100 | number: '1.0-2') || '0'}}</p>
                    </ng-container>
                <!-- </ng-container> -->
                <!-- </div> -->
            </div>
            <div  class="col-sm-6 mb-3" *ngIf="source == 'edf' && assumptionData?.energy?.gasUnitRate?.value">
                <label for="unitPriceGas" class="fs-14 fw400 text-brightPurple mb-1">Gas Rate </label>
                <p class="fs-14 fw400 mb-0"><strong>Unit Rate:</strong> {{ (assumptionData.energy.gasUnitRate.value * 100 | number: '1.0-2') || '0'}} p/kWh</p>
                <p class="fs-14 fw400 mb-0"><strong>Standing Charge:</strong> {{ (assumptionData.energy.gasStandingCharge?.value *100 | number: '1.0-2') || '0'}} p/day</p>
            </div>
            <div *ngIf="source != 'edf'" class="col-lg-3 col-md-4 col-sm-6 mb-lg-0 mb-3">
                <label for="unitPriceElec" class="fs-14 fw400 text-brightPurple mb-1">Electricity Unit Price (Rates are in p/kWh)</label>
                <p class="fs-16 fw400 mb-0">{{(assumptionData?.energy?.elecUnitRate?.value * 100 | number: '1.0-2') || '0'}}</p>
            </div>
            <div  class="col-lg-3 col-md-4 col-sm-6 mb-lg-0 mb-3" *ngIf="source != 'edf' && assumptionData?.energy?.gasUnitRate?.value">
                <label for="unitPriceGas" class="fs-14 fw400 text-brightPurple mb-1">Gas Unit Price (Rates are in p/kWh)</label>
                <p class="fs-16 fw400 mb-0">{{ (assumptionData.energy.gasUnitRate.value * 100 | number: '1.0-2') || '0'}}</p>
            </div>
            <hr *ngIf="source == 'edf'">
            <div class="col-lg-3 col-md-4 col-sm-6 mb-lg-0 mb-3">
                <label class="fs-14 fw400 text-brightPurple mb-1">LED (Percentage)</label>
                <p class="fs-16 fw400 mb-0">{{ assumptionData?.lighting?.ledPercent?.value || '0' }}</p>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-lg-0 mb-0">
                <label for="heatingSource" class="fs-14 fw400 text-brightPurple mb-1">Heating source</label>
                <p class="fs-16 fw400 mb-0">{{ assumptionData?.building?.heatingSource?.value || '-'}}</p>
            </div>
        </div>
        <hr>
        <div class="row mt-lg-4 mt-3">
            <div class="col-12">
                <h3 class="fs-16 fw600 text-bodyGrey mb-2">Energy splits(Electric)</h3>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <label class="fs-14 fw400 text-brightPurple mb-1">Cooking</label>
                <p class="fs-16 fw400 mb-0">{{ (assumptionData?.energy?.split?.cateringElec?.value || 0 ) | number:
                    '1.0-2' }}%
                </p>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <label class="fs-14 fw400 text-brightPurple mb-1">Heating</label>
                <p class="fs-16 fw400 mb-0">{{ (assumptionData?.energy?.split?.heatingElec?.value || 0 ) | number: '1.0-2'
                    }}%
                </p>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
                <label class="fs-14 fw400 text-brightPurple mb-1">Hot water</label>
                <p class="fs-16 fw400 mb-0">{{ (assumptionData?.energy?.split?.hotwaterElec?.value || 0 ) | number:
                    '1.0-2' }}%
                </p>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
                <label class="fs-14 fw400 text-brightPurple mb-1">Lighting</label>
                <p class="fs-16 fw400 mb-0">{{ (assumptionData?.energy?.split?.lighting?.value || 0 ) | number: '1.0-2'
                    }}%
                </p>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6">
                <label class="fs-14 fw400 text-brightPurple mb-1">Others</label>
                <p class="fs-16 fw400 mb-0">{{ (assumptionData?.energy?.split?.others?.value || 0 ) | number: '1.0-2' }}%
                </p>
            </div>
        </div>
        <div class="row mt-lg-4 mt-3" *ngIf="assumptionData?.mprn?.length">
            <div class="col-12">
                <h3 class="fs-16 fw600 text-bodyGrey mb-2">Energy splits(Gas)</h3>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-lg-0 mb-3">
                <label class="fs-14 fw400 text-brightPurple mb-1">Cooking</label>
                <p class="fs-16 fw400 mb-0">{{ (assumptionData?.energy?.split?.cateringGas?.value || 0 ) | number: '1.0-2'
                    }}%
                </p>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-lg-0 mb-3">
                <label class="fs-14 fw400 text-brightPurple mb-1">Heating</label>
                <p class="fs-16 fw400 mb-0">{{ (assumptionData?.energy?.split?.heatingGas?.value || 0 ) | number: '1.0-2'
                    }}%
                </p>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 mb-lg-0 mb-3">
                <label class="fs-14 fw400 text-brightPurple mb-1">Hot water</label>
                <p class="fs-16 fw400 mb-0">{{ (assumptionData?.energy?.split?.hotwaterGas?.value || 0 ) | number: '1.0-2'
                    }}%
                </p>
            </div>
        </div>
    </div>
</div>